import { Box, Grid, Typography } from "@mui/material";
import { Landing } from "@brand";
import Maybe from "components/common/Maybe";
import styles from "./CoverageOptions.module.css";

interface CoverageOptionsProps {
  onSelect?: () => void;
}

const CoverageOptions = ({ onSelect }: CoverageOptionsProps): JSX.Element | null => {
  const options = Landing.coverageOptions;

  if (!options) {
    return null;
  }

  return (
    <Box className={styles.section}>
      <Typography variant={"h5"} component={"h2"} className={styles.heading}>
        {options.heading}
      </Typography>

      <Grid container spacing={3} alignItems={"stretch"}>
        {options.items.map((item) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Box
              component={onSelect ? "button" : "div"}
              type={onSelect ? "button" : undefined}
              onClick={onSelect}
              aria-label={onSelect ? `${item.title} — ${Landing.heroCta}` : undefined}
              className={[
                styles.card,
                item.note ? styles.cardRecommended : "",
                onSelect ? styles.cardAction : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <Typography variant={"h6"} component={"h3"} className={styles.cardTitle}>
                {item.title}
              </Typography>
              <Typography className={styles.cardText}>{item.text}</Typography>
              <Maybe test={item.note}>
                <Typography component={"span"} className={styles.cardNote}>
                  {item.note}
                </Typography>
              </Maybe>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Maybe test={options.footnote}>
        <Typography className={styles.footnote}>{options.footnote}</Typography>
      </Maybe>
    </Box>
  );
};

export default CoverageOptions;
